// @flow

import {
  SHOW_NAV, NAV, NAV_MINIFIED, MENU_TOGGLE
  } from '../constants/action-types';
  
  const initialState = {
    navMinified: false,
    screen: 'Main',
    showNav: true
  };

  
  const navReducer = (state: Object = initialState, action = {}) => {
    
    switch (action.type) {
      
      case NAV:
        return Object.assign({}, state, 
            { screen: (action.payload && action.payload.pathname || '').substr(1)})
      
      case MENU_TOGGLE: 
          return Object.assign({}, state, 
            {showNav: !state.showNav})

      case NAV_MINIFIED: 
        return Object.assign({}, state, {
          navMinified: action.payload })
    
      case SHOW_NAV: 
        return Object.assign({}, state, {
          showNav: action.payload })

      default: return state
    }
  };
  
  export default navReducer;
  


// WEBPACK FOOTER //
// ./src/reducers/nav-reducer.js